module.exports = __webpack_public_path__ + "oleole.png?225bc0271ce039543db2524bb8e9ebda";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/oleole.png
// module id = 989
// module chunks = 2